import React from 'react';
import { Button, TextField } from '@material-ui/core';
import Modal from 'components/Modal';
import classes from './Modal.module.scss';
import T from 'i18n-react';
import { setLanguageLocale } from 'util/icwUtility';
import { PRODUCT_MANAGEMENT_PATH } from 'shared/path';

setLanguageLocale(T, [PRODUCT_MANAGEMENT_PATH]);

const AddNewModal = ({
  open,
  tabs = [],
  title,
  item,
  placeholder,
  handleClose,
  createNew,
  onDelete,
}) => {
  const [value, setValue] = React.useState(item?.value ?? '');

  const [isDuplicated, setIsDuplicated] = React.useState(false);

  React.useEffect(() => {
    setValue(item?.value ?? '');
  }, [item]);
  React.useEffect(() => {
    if (value && tabs.length) {
      setIsDuplicated(tabs.find((tab) => tab.trim() === value.trim()));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const isEdit = !!item?.id;
  return (
    <Modal
      modalProps={{
        className: { classRoot: classes.root },
        open,
        handleClose: () => {
          setValue('');
          handleClose();
        },
        title,
        size: 'small',
        footer: (
          <>
            <Button
              className={classes.button}
              color='primary'
              disabled={!value || isDuplicated}
              variant='contained'
              onClick={() => {
                createNew(value, item);
                setValue('');
              }}>
              {isEdit
                ? T.translate('modal.tab.form.button.update')
                : T.translate('modal.tab.form.button.create')}
            </Button>
            {isEdit && (
              <Button
                className={classes.defaultButton}
                disabled={!value}
                variant='outlined'
                onClick={() => {
                  onDelete(item);
                  setValue('');
                }}>
                {T.translate('modal.tab.form.button.delete')}
              </Button>
            )}
          </>
        ),
      }}>
      <TextField
        className={classes.textField}
        variant='outlined'
        placeholder={placeholder}
        value={value}
        onChange={(event) => {
          setValue(event.target.value);
        }}
      />
      <span style={{ color: 'red', visibility: value && isDuplicated ? 'visible' : 'hidden' }}>
        {`${T.translate('modal.tab.form.error.message1')}'${value}'${T.translate(
          'modal.tab.form.error.message2'
        )}`}
      </span>
    </Modal>
  );
};

export default AddNewModal;
